/**
 * Dados públicos da loja usados em banners / vitrine.
 * Pode sobrescrever via .env (REACT_APP_STORE_*).
 */
export type StoreBranding = {
  name: string;
  tagline: string;
  logoFileName: string;
  whatsappE164: string;
  whatsappDisplay: string;
  instagram: string;
  facebook: string;
  brandRed: string;
};

export const STORE_BRANDING: StoreBranding = {
  name: process.env.REACT_APP_STORE_NAME || 'R Motors',
  tagline:
    process.env.REACT_APP_STORE_TAGLINE ||
    'Condições especiais para você sair de carro com a R Motors',
  logoFileName: process.env.REACT_APP_STORE_LOGO || 'MARCA - R MOTORS horizontal.png',
  whatsappE164: (process.env.REACT_APP_STORE_WHATSAPP || '5598920073506').replace(/\D/g, ''),
  whatsappDisplay:
    process.env.REACT_APP_STORE_WHATSAPP_DISPLAY || '(98) 92007-3506',
  instagram: (process.env.REACT_APP_STORE_INSTAGRAM || 'rmotors.slz').replace(/^@/, ''),
  facebook: (process.env.REACT_APP_STORE_FACEBOOK || 'rmotors.slz').replace(/^@/, ''),
  brandRed: process.env.REACT_APP_STORE_BRAND_RED || '#DD2F30',
};

/** Link para conversar com a loja no WhatsApp (sem mensagem pronta). */
export const storeWhatsappLink = `https://wa.me/${STORE_BRANDING.whatsappE164}`;

export const getStoreLogoUrl = (): string => {
  const base = `${window.location.origin}${process.env.PUBLIC_URL || ''}`;
  return `${base}/assets/logos/${encodeURIComponent(STORE_BRANDING.logoFileName)}`;
};
